import { createElement } from '@max/max';
import Text from '@hfe/max-text';
import { PrizeStatus } from '@/types';
import { formatTimestampToDate } from '@/utils/common';
import CountDown from '../coupon-usage-record/CountDown';
import './index.scss';
import { isExpireOverDay } from '@/utils/common';
/**
 * 过期时间展示组件
 * 根据奖励状态和过期时间显示不同的文案或倒计时
 *
 * 显示规则：
 * - CAN_DRAW: 不显示
 * - DRAWN/NOT_USED + expireIsOverDay=true: "有效期至YYYY.MM.DD"
 * - DRAWN/NOT_USED + expireIsOverDay=false + expireTime: "HH:MM:SS后到期" (倒计时)
 * - DRAWN/NOT_USED + no expireTime: 不显示
 * - 其他: 不显示
 */
const ExpireTimeDisplay = ({ prize, textColor = '#111111' }) => {
    // 根据 prizeStatus 显示不同的过期信息
    if (prize.prizeStatus === PrizeStatus.CAN_DRAW) {
        return null;
    }
    const expireIsOverDay = isExpireOverDay(prize.expireTime);
    if (prize.prizeStatus === PrizeStatus.DRAWN || prize.prizeStatus === PrizeStatus.NOT_USED) {
        // 已领取，倒计时大于1天，显示日期
        if (expireIsOverDay) {
            const { month, day } = formatTimestampToDate(prize.expireTime);
            // 将月日转换为YYYY.MM.DD格式
            const year = new Date(prize.expireTime).getFullYear();
            return <Text className="expire-time-display" numberOfLines={1} style={{
                color: textColor
            }}>
          {`有效期至${year}.${month}.${day}`}
        </Text>;
        }
        // 判断是否需要显示倒计时
        const showCountDown = !expireIsOverDay && prize.expireTime;
        // 已领取，倒计时小于等于1天，显示倒计时
        if (showCountDown) {
            return <CountDown endTime={prize.expireTime} suffix="后到期"/>;
        }
        return null;
    }
    // 其他状态
    return null;
};
export default ExpireTimeDisplay;
